<nav [ngClass]="{'no-handheld': !isHandheld}" class="navbar bg-light d-flex justify-content-between flex-row-reverse border-bottom border-2 mb-0 pt-0">
  <div class="mx-2" *ngIf="isHandheld">
    <button class="navbar-toggler border-left" type="button" (click)="toggleSidebar.emit(!isCollapsed)" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>

  <div class="d-flex flex-column text-end m-auto border-left d-none d-lg-block mx-3">
    <div class="d-flex">
      <span class="d-flex justify-content-between me-4 my-auto" *ngIf="!!userProfile">
        <span>
          <span class="text-tdw ms-auto">{{userProfile.username}}</span>
          <i class="fa fa-user ms-2 pointer text-secondary" [routerLink]="['/user-profile']" ngbTooltip="View User Profile"></i>
        </span>
      </span>
      <div class="d-flex my-auto">
        <input #q type="text" style="width: 15rem;" (keyup.enter)="search.emit(q.value)" class="form-control" placeholder="Search Products...">
        <i class="fa fa-search mx-2 my-auto"></i>
        <button id="admin" title="Admin" class="btn btn-outline-secondary my-auto border" *ngIf="userProfile &&
        (userProfile.roles.includes('ProductSelector.FittingsAdmin') ||
        userProfile.roles.includes('ProductSelector.ClosuresAdmin') ||
        userProfile.roles.includes('ProductSelector.SealingElementAdmin'))" [routerLink]="['admin']"><i class="fa-solid fa-lock"></i></button>
      </div>
    </div>

  </div>

  <span class="flex-fill">&nbsp;</span>
  <a class="text-decoration-none" [routerLink]="['/']">
    <div class="d-flex">
      <a [routerLink]="['/']">
        <img src="https://assets.tdwilliamson.com/img/CircleMark-darkbkgd-PNG.png" alt="" width="55">
      </a>
      <span class="fs-4 my-auto fw-light text-danger">{{appName}}</span>


    </div>
  </a>
</nav>
